<template>
    <div class="main">
        <div class="grid-container">
            <div class="grid-x">
                <div class="small-12 cell">
                    <h1>Your profile</h1>
                    <p>You're logged in as {{ user.email }}.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'profile',
    data () {
        return {
            user: firebase.auth().currentUser
        }
    },
    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// Profile.vue?769baf53